import { PERMISSIONS } from "~/constants/permissions.constants";

export const permissionsTree = [
  // ==========================================
  // DASHBOARD
  // ==========================================
  {
    title: "Dashboard",
    key: "Dashboard_PARENT",
    icon: "dashboard",
    plans: ["starter", "premium"],
    children: [
      {
        title: "Gráficos",
        key: "Gráficos_PARENT",
        plans: ["starter", "premium"],
        children: [
          { title: "Mensalidade x Recebido", key: PERMISSIONS.graphs.monthlyPayments.view, plans: ["starter", "premium"], info: "Gráfico comparativo entre mensalidades cobradas e valores recebidos" },
          { title: "Quantidade de Clientes", key: PERMISSIONS.graphs.customersCount.view, plans: ["starter", "premium"], info: "Gráfico com a evolução do número de clientes ativos" },
          { title: "Clientes por tipo", key: PERMISSIONS.graphs.customersByType.view, plans: ["starter", "premium"], info: "Distribuição de clientes por tipo de empresa (MEI, ME, EPP, etc.)" },
          { title: "Serviços extras / Tarefas", key: PERMISSIONS.graphs.dashTasks.view, plans: ["premium"], info: "Resumo de serviços extras agrupados por tarefa" },
          { title: "Serviços extras / Financeiro", key: PERMISSIONS.graphs.extraPayments.view, plans: ["premium"], info: "Resumo financeiro dos serviços extras cobrados" },
          { title: "Tarefas do mês", key: PERMISSIONS.graphs.calendarTasks.view, plans: ["starter", "premium"], info: "Visão geral das tarefas programadas para o mês atual" },
          { title: "Certificados", key: PERMISSIONS.graphs.certificates.view, plans: ["premium"], info: "Resumo do status dos certificados digitais dos clientes" },
          { title: "Leads", key: PERMISSIONS.graphs.leads.view, plans: ["premium"], info: "Gráfico de funil e evolução dos leads captados" },
        ],
      },
    ],
  },

  // ==========================================
  // CLIENTES
  // ==========================================
  {
    title: "Clientes",
    key: "Clientes_PARENT",
    icon: "team",
    plans: ["starter", "premium"],
    children: [
      { title: "Visualizar", key: PERMISSIONS.customers.view, plans: ["starter", "premium"], info: "Acessar a lista de clientes e visualizar seus dados" },
      { title: "Criar", key: PERMISSIONS.customers.create, plans: ["starter", "premium"], info: "Cadastrar novos clientes no sistema" },
      { title: "Editar", key: PERMISSIONS.customers.edit, plans: ["starter", "premium"], info: "Alterar informações de clientes existentes" },
      { title: "Remover", key: PERMISSIONS.customers.delete, plans: ["starter", "premium"], info: "Excluir clientes do sistema permanentemente" },
    ],
  },

  // ==========================================
  // TAREFAS
  // ==========================================
  {
    title: "Tarefas",
    key: "Tarefas_SECTION",
    isSection: true,
    icon: "schedule",
    plans: ["starter", "premium"],
    children: [
      // Calendário
      {
        title: "Calendário",
        key: "Calendario_PARENT",
        icon: "calendar",
        sectionLabel: "Calendário",
        plans: ["starter", "premium"],
        children: [
          { title: "Tarefas do mês", key: PERMISSIONS.calendarTasks.view, plans: ["starter", "premium"], info: "Visualizar o calendário de tarefas mensais e seus status" },
          { title: "Cadastro de tarefas", key: PERMISSIONS.calendarTasks.create, plans: ["starter", "premium"], info: "Criar e configurar novas tarefas recorrentes no calendário" },
        ],
      },
      {
        title: "Conferência",
        key: PERMISSIONS.conference.view,
        icon: "audit",
        plans: ["starter", "premium"],
        info: "Conferência mensal das guias de pagamento: acompanhar por tarefa quais clientes já foram avisados",
      },
      // Controle
      {
        title: "Solicitações de NFs",
        key: PERMISSIONS.solicitations.view,
        icon: "inbox",
        sectionLabel: "Controle",
        plans: ["premium"],
        info: "Gerenciar solicitações de notas fiscais recebidas dos clientes",
      },
      {
        title: "Checklist",
        key: "Checklist_PARENT",
        icon: "check-square",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.checklist.view, plans: ["premium"], info: "Acessar o checklist de obrigações e acompanhar o progresso" },
          { title: "Revisar", key: PERMISSIONS.checklist.review, plans: ["premium"], info: "Marcar tarefas como revisadas e aprovar entregas" },
          {
            title: "Colunas",
            key: "Colunas_PARENT",
            plans: ["premium"],
            children: [
              { title: "Legalização", key: PERMISSIONS.checklist.columns.legalization, plans: ["starter", "premium"], info: "Visualizar e gerenciar a coluna de tarefas de legalização" },
              { title: "Administrativo", key: PERMISSIONS.checklist.columns.administrative, plans: ["starter", "premium"], info: "Visualizar e gerenciar a coluna de tarefas administrativas" },
              { title: "Contábil", key: PERMISSIONS.checklist.columns.accounting, plans: ["starter", "premium"], info: "Visualizar e gerenciar a coluna de tarefas contábeis" },
              { title: "Fiscal", key: PERMISSIONS.checklist.columns.fiscal, plans: ["starter", "premium"], info: "Visualizar e gerenciar a coluna de tarefas fiscais" },
              { title: "Pessoal", key: PERMISSIONS.checklist.columns.personal, plans: ["starter", "premium"], info: "Visualizar e gerenciar a coluna de tarefas do departamento pessoal" },
              { title: "Sucesso do cliente", key: PERMISSIONS.checklist.columns.cs, plans: ["starter", "premium"], info: "Visualizar e gerenciar a coluna de sucesso do cliente" },
            ],
          },
        ],
      },
      {
        title: "Convenções Coletivas",
        key: PERMISSIONS.conventions.view,
        icon: "file-text",
        plans: ["premium"],
        info: "Acessar e consultar as convenções coletivas de trabalho",
      },
    ],
  },

  // ==========================================
  // FINANCEIRO
  // ==========================================
  {
    title: "Financeiro",
    key: "Financeiro_SECTION",
    isSection: true,
    icon: "dollar",
    plans: ["starter", "premium"],
    children: [
      // Receitas
      {
        title: "Mensalidades",
        key: "Mensalidades_PARENT",
        icon: "dollar",
        sectionLabel: "Receitas",
        plans: ["starter", "premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.financial.monthlyPayments.view, plans: ["starter", "premium"], info: "Acessar a tela de mensalidades e consultar valores cobrados" },
          { title: "Editar", key: PERMISSIONS.financial.monthlyPayments.edit, plans: ["starter", "premium"], info: "Alterar valores, datas e status das mensalidades" },
          { title: "Remover", key: PERMISSIONS.financial.monthlyPayments.delete, plans: ["starter", "premium"], info: "Excluir registros de mensalidades" },
        ],
      },
      {
        title: "Extras",
        key: "Extras_PARENT",
        icon: "plus",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.extraServices.view, plans: ["premium"], info: "Consultar serviços extras cobrados dos clientes" },
          { title: "Editar", key: PERMISSIONS.extraServices.edit, plans: ["premium"], info: "Alterar informações e valores de serviços extras" },
          { title: "Remover", key: PERMISSIONS.extraServices.delete, plans: ["premium"], info: "Excluir registros de serviços extras" },
        ],
      },
      {
        title: "Contas a Receber",
        key: "ContasReceber_PARENT",
        icon: "dollar",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.financial.contasReceber.view, plans: ["premium"], info: "Acessar e consultar as contas a receber" },
          { title: "Editar", key: PERMISSIONS.financial.contasReceber.edit, plans: ["premium"], info: "Criar, alterar e dar baixa em contas a receber" },
        ],
      },
      // Despesas
      {
        title: "Contas a Pagar",
        key: "ContasPagar_PARENT",
        icon: "wallet",
        sectionLabel: "Despesas",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.financial.contasPagar.view, plans: ["premium"], info: "Acessar e consultar as contas a pagar" },
          { title: "Editar", key: PERMISSIONS.financial.contasPagar.edit, plans: ["premium"], info: "Criar, alterar e dar baixa em contas a pagar" },
        ],
      },
      {
        title: "Comissões",
        key: "Comissoes_PARENT",
        icon: "percentage",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.refunds.view, plans: ["premium"], info: "Consultar comissões de parceiros e indicadores" },
          { title: "Editar", key: PERMISSIONS.refunds.edit, plans: ["premium"], info: "Alterar valores e configurações de comissões" },
          { title: "Remover", key: PERMISSIONS.refunds.delete, plans: ["premium"], info: "Excluir registros de comissões" },
        ],
      },
      // Outros
      {
        title: "Extrato",
        key: "Extrato_PARENT",
        icon: "bar-chart",
        sectionLabel: "Outros",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.financial.extrato.view, plans: ["premium"], info: "Acessar o extrato consolidado de movimentações financeiras" },
        ],
      },
      {
        title: "Bancos",
        key: "Bancos_PARENT",
        icon: "bank",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.financial.bancos.view, plans: ["premium"], info: "Consultar contas bancárias cadastradas e seus saldos" },
          { title: "Editar", key: PERMISSIONS.financial.bancos.edit, plans: ["premium"], info: "Cadastrar e editar contas bancárias" },
        ],
      },
      {
        title: "Conciliação Bancária",
        key: "ConciliacaoBancaria_PARENT",
        icon: "reconciliation",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.financial.bankReconciliation.view, plans: ["premium"], info: "Acessar a tela de conciliação e visualizar transações" },
          { title: "Editar", key: PERMISSIONS.financial.bankReconciliation.edit, plans: ["premium"], info: "Conciliar transações bancárias com lançamentos do sistema" },
        ],
      },
    ],
  },

  // ==========================================
  // COMPLIANCE
  // ==========================================
  {
    title: "Compliance",
    key: "Compliance_SECTION",
    isSection: true,
    icon: "audit",
    plans: ["premium"],
    children: [
      // Societário
      {
        title: "Painel Societário",
        key: "Societario_PARENT",
        icon: "dashboard",
        sectionLabel: "Societário",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.corporate.view, plans: ["premium"], info: "Acessar o painel de aberturas e encerramentos de empresas" },
          { title: "Criar", key: PERMISSIONS.corporate.create, plans: ["premium"], info: "Iniciar novos processos de abertura ou encerramento" },
          { title: "Vincular cobrança", key: PERMISSIONS.corporate.createBillsToPay, plans: ["premium"], info: "Vincular cobranças a processos societários" },
          { title: "Visualizar dept. financeiro", key: PERMISSIONS.corporate.financial.view, plans: ["premium"], info: "Acessar a aba financeira dentro do painel societário" },
        ],
      },
      {
        title: "Certificados",
        key: PERMISSIONS.certificates.view,
        icon: "safety-certificate",
        plans: ["premium"],
        info: "Gerenciar certificados digitais dos clientes (A1, A3, e-CNPJ, etc.)",
      },
      {
        title: "Lembretes",
        key: PERMISSIONS.procurations.view,
        icon: "bell",
        plans: ["premium"],
        info: "Gerenciar lembretes e procurações dos clientes",
      },
      // Fiscal
      {
        title: "IRPF",
        key: "IRPF_PARENT",
        icon: "file-done",
        sectionLabel: "Fiscal",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.irpf.view, plans: ["premium"], info: "Acessar o painel de declarações de IRPF dos clientes" },
          { title: "Sumário", key: PERMISSIONS.irpf.summary.view, plans: ["premium"], info: "Visualizar o resumo consolidado das declarações de IRPF" },
        ],
      },
      {
        title: "Malha Fiscal",
        key: PERMISSIONS.irpf.malhaFina.view,
        icon: "audit",
        plans: ["premium"],
        info: "Acessar o módulo de malha fiscal e verificar pendências na Receita Federal",
      },
      {
        title: "Dívidas Tributárias",
        key: PERMISSIONS.irpf.dividasTributarias.view,
        icon: "warning",
        plans: ["premium"],
        info: "Consultar e gerenciar dívidas tributárias dos clientes",
      },
    ],
  },

  // ==========================================
  // COMERCIAL
  // ==========================================
  {
    title: "Comercial",
    key: "Comercial_SECTION",
    isSection: true,
    icon: "rise",
    plans: ["premium"],
    children: [
      {
        title: "Prospecção Ativa",
        key: PERMISSIONS.prospecting.view,
        icon: "user-add",
        plans: ["premium"],
        info: "Gerenciar prospects e cadências de prospecção ativa",
      },
      {
        title: "Prospecção Passiva (Leads)",
        key: PERMISSIONS.leads.view,
        icon: "usergroup-add",
        plans: ["premium"],
        info: "Gerenciar leads recebidos e acompanhar o funil de conversão",
      },
      {
        title: "Social Selling",
        key: PERMISSIONS.socialSelling.view,
        icon: "share-alt",
        plans: ["premium"],
        info: "Gerenciar cadências e contatos de social selling",
      },
      {
        title: "Indicação Premiada",
        key: PERMISSIONS.referralProgram.view,
        icon: "gift",
        plans: ["premium"],
        info: "Acessar o programa de indicação premiada e acompanhar indicações",
      },
      {
        title: "Marketing",
        key: "Marketing_PARENT",
        icon: "rocket",
        plans: ["premium"],
        isBeta: true,
        children: [
          { title: "Missões", key: PERMISSIONS.boards.view, plans: ["premium"], info: "Gerenciar missões e boards de marketing" },
        ],
      },
      {
        title: "Recuperação Tributária",
        key: PERMISSIONS.leadsRT.view,
        icon: "file-search",
        plans: ["premium"],
        info: "Acessar o módulo de recuperação tributária e gerenciar oportunidades",
      },
    ],
  },

  // ==========================================
  // RELATÓRIOS
  // ==========================================
  {
    title: "Relatórios",
    key: "Relatorios_SECTION",
    isSection: true,
    icon: "bar-chart",
    plans: ["premium"],
    children: [
      // Financeiro
      {
        title: "Inadimplentes",
        key: PERMISSIONS.reports.defaulters,
        icon: "warning",
        sectionLabel: "Financeiro",
        plans: ["premium"],
        info: "Relatório de clientes inadimplentes com valores em atraso",
      },
      {
        title: "Prazos",
        key: PERMISSIONS.documentsDeadline.view,
        icon: "clock-circle",
        plans: ["premium"],
        info: "Relatório de documentos e obrigações com prazos próximos ou vencidos",
      },
      // Desempenho
      {
        title: "Controle de honorários",
        key: PERMISSIONS.honoraries.view,
        icon: "dollar",
        sectionLabel: "Desempenho",
        plans: ["premium"],
        info: "Relatório de honorários contábeis por cliente e período",
      },
      {
        title: "KPIs",
        key: PERMISSIONS.feedbacks.view,
        icon: "line-chart",
        plans: ["premium"],
        info: "Indicadores de desempenho e métricas de produtividade da equipe",
      },
      // Societário
      {
        title: "Quadro de Sócios",
        key: PERMISSIONS.reports.partners,
        icon: "team",
        sectionLabel: "Societário",
        plans: ["premium"],
        info: "Relatório consolidado do quadro societário dos clientes",
      },
    ],
  },

  // ==========================================
  // RECURSOS
  // ==========================================
  {
    title: "Recursos",
    key: "Recursos_SECTION",
    isSection: true,
    icon: "cloud-upload",
    plans: ["starter", "premium"],
    children: [
      {
        title: "Documentos enviados",
        key: PERMISSIONS.documents.view,
        icon: "file",
        plans: ["starter", "premium"],
        info: "Consultar documentos enviados aos clientes via sistema",
      },
      {
        title: "E-mails enviados",
        key: PERMISSIONS.sentEmails.view,
        icon: "mail",
        plans: ["starter", "premium"],
        info: "Consultar histórico de e-mails enviados pelo sistema",
      },
      // Plugins
      {
        title: "Formulários",
        key: "Plugins_Formularios",
        icon: "form",
        sectionLabel: "Plugins",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.plugins.view, plans: ["premium"], info: "Acessar formulários personalizados e suas respostas" },
        ],
      },
      {
        title: "Contador de Cliques",
        key: "Plugins_ClickCounter",
        icon: "link",
        plans: ["premium"],
        children: [
          { title: "Visualizar", key: PERMISSIONS.plugins.view, plans: ["premium"], info: "Acessar o contador de cliques em links compartilhados" },
        ],
      },
      // Outros
      {
        title: "Base de conhecimento",
        key: PERMISSIONS.knowledgeBase.view,
        icon: "book",
        sectionLabel: "Outros",
        plans: ["premium"],
        info: "Acessar artigos e tutoriais da base de conhecimento interna",
      },
      {
        title: "Links",
        key: PERMISSIONS.links.view,
        icon: "link",
        plans: ["premium"],
        info: "Gerenciar links e atalhos compartilhados com a equipe",
      },
    ],
  },

  // ==========================================
  // CONFIGURAÇÕES
  // ==========================================
  {
    title: "Configurações",
    key: "Configuracoes_SECTION",
    isSection: true,
    icon: "setting",
    plans: ["starter", "premium"],
    children: [
      // Empresa
      {
        title: "Dados da Empresa",
        key: PERMISSIONS.settings.empresa.view,
        icon: "bank",
        sectionLabel: "Empresa",
        plans: ["starter", "premium"],
        info: "Editar informações cadastrais da empresa (CNPJ, endereço, logo, etc.)",
      },
      // Sistema
      {
        title: "Tarefas do Checklist",
        key: PERMISSIONS.settings.checklistTasks.view,
        icon: "check-square",
        sectionLabel: "Sistema",
        plans: ["starter", "premium"],
        info: "Configurar quais tarefas aparecem no checklist mensal",
      },
      {
        title: "Cadastro de Tarefas",
        key: PERMISSIONS.settings.taskRegistration.view,
        icon: "form",
        plans: ["starter", "premium"],
        info: "Gerenciar o cadastro de tipos de tarefas disponíveis no sistema",
      },
      {
        title: "Variáveis do Sistema",
        key: PERMISSIONS.settings.systemVariables.view,
        icon: "control",
        plans: ["starter", "premium"],
        info: "Configurar origens, cadências de prospecção e categorias financeiras",
      },
      {
        title: "Módulo Mensalidades",
        key: PERMISSIONS.settings.monthlyModule.view,
        icon: "dollar",
        plans: ["starter", "premium"],
        info: "Configurar parâmetros do módulo de mensalidades (vencimentos, reajustes)",
      },
      {
        title: "Docs Esporádicos",
        key: PERMISSIONS.settings.sporadicDocs.view,
        icon: "file-text",
        plans: ["starter", "premium"],
        info: "Configurar tipos de documentos esporádicos por departamento",
      },
      // Integrações
      {
        title: "Integrações",
        key: PERMISSIONS.settings.integracoes.view,
        icon: "api",
        sectionLabel: "Integrações",
        plans: ["premium"],
        info: "Configurar WhatsApp por departamento e extensão WhatsApp",
      },
      // Acesso
      {
        title: "Usuários",
        key: PERMISSIONS.users.view,
        icon: "team",
        sectionLabel: "Acesso",
        plans: ["starter", "premium"],
        info: "Gerenciar contas de usuários, convidar e desativar membros",
      },
      {
        title: "Permissões",
        key: PERMISSIONS.settings.permissoes.view,
        icon: "safety",
        plans: ["starter", "premium"],
        info: "Gerenciar grupos de permissões e definir níveis de acesso",
      },
    ],
  },
];
